/**
 * Data Export Module
 * Handles exporting stock data to CSV
 */

import { state } from '../state.js';
import { showToast, showError } from '../ui/ui-manager.js';

/**
 * Export current stock data to CSV
 */
export function exportToCSV() {
    if (!state.stockData || !state.stockData.candleData || state.stockData.candleData.length === 0) {
        showError('エクスポートするデータがありません。');
        return;
    }

    try {
        const data = state.stockData.candleData;
        const symbol = state.currentSymbol || 'STOCK';
        const period = state.currentPeriod || '1M';

        // Define CSV headers
        const headers = ['Date', 'Open', 'High', 'Low', 'Close'];

        // Convert data to CSV rows
        const rows = data.map(candle => {
            // candle.time is usually 'YYYY-MM-DD' string or timestamp
            // If it's a lightweight-charts business day object, we might need conversion, 
            // but our API usually returns standard YYYY-MM-DD strings for time.
            let dateStr = candle.time;
            if (typeof candle.time === 'object') {
                dateStr = `${candle.time.year}-${String(candle.time.month).padStart(2, '0')}-${String(candle.time.day).padStart(2, '0')}`;
            }

            return [
                dateStr,
                candle.open,
                candle.high,
                candle.low,
                candle.close
            ].join(',');
        });

        // Combine headers and rows
        const csvContent = [headers.join(','), ...rows].join('\n');

        // Create Blob and download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        const timestamp = new Date().toISOString().slice(0, 10);
        link.setAttribute('href', url);
        link.setAttribute('download', `${symbol}_${period}_${timestamp}.csv`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        showToast('CSVエクスポートが完了しました。', 'success');

    } catch (error) {
        console.error('Export failed:', error);
        showError('CSVエクスポートに失敗しました。');
    }
}
